import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const CTABanner = ({ title, subtitle, buttonText, buttonLink }) => {
  return (
    <section data-testid="cta-banner" className="py-12 sm:py-20 bg-orange-500 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-white rounded-full translate-y-1/2 -translate-x-1/2" />
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white mb-4 tracking-tight">
          {title || "Ready to Transform Your Workspace?"}
        </h2>
        <p className="text-white/90 text-base sm:text-lg mb-8 max-w-2xl mx-auto font-body leading-relaxed">
          {subtitle || "Join hundreds of professionals who chose Coffice 24x7 for flexible, affordable, and inspiring workspaces."}
        </p>
        <Link
          to={buttonLink || "/contact"}
          data-testid="cta-banner-button"
          className="inline-flex items-center gap-2 rounded-full bg-white text-orange-600 font-semibold px-8 py-3.5 hover:bg-slate-50 active:scale-95 transition-all shadow-lg"
        >
          {buttonText || "Book a Visit"}
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
};
